import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';

class SavedJobAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  getSavedJobsForOrg(organizationId) {
    return this.api.get(`/saved/org/${organizationId}`)
      .then(data => data.body);
  }

  launchSavedJob(savedJobId, optionsPayload) {
    return this.api.post(`/saved/run/${savedJobId}`, optionsPayload)
      .then(data => data.body);
  }

  getJob(savedJobId) {
    return this.api.get(`/saved/${savedJobId}`)
      .then(data => data.body);
  }

  createJob(organizationId, requestJson) {
    return this.api.post('/saved', requestJson)
      .then(data => ({ message: data.body }));
  }

  updateJob(savedJobId, jobJson) {
    return this.api.put(`/saved/${savedJobId}`, jobJson)
      .then(data => ({ message: data.body }));
  }

  deleteJob(savedJobId) {
    return this.api.del(`/saved/${savedJobId}`)
      .then(data => ({ message: data.body }));
  }

  getSchedule(savedJobId) {
    return this.api.get(`/saved/${savedJobId}/schedule`)
      .then(data => ({ message: data.body }));
  }

  createSchedule(savedJobId, scheduleJson) {
    return this.api.post('/saved/schedule', scheduleJson)
      .then(data => ({ message: data.body }));
  }

  updateSchedule(savedJobId, scheduleJson) {
    return this.api.put(
      `/saved/${savedJobId}/schedule`,
      { schedulableJob: { ...scheduleJson } },
    ).then(data => ({ message: data.body }));
  }

  deleteSchedule(savedJobId) {
    return this.api.del(`/saved/${savedJobId}/schedule`)
      .then(data => ({ message: data.body }));
  }
}

class SavedJobsAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getJobServiceUrl(), token);
    this.savedjobs = new SavedJobAPIWrapper(this);
  }
}

export default SavedJobsAPI;
